import * as React from "react";
import "./tab.component.css";
import { useEffect, useState } from "react";
import { MessageResponse } from "../../model/MessageResponse";
import {
  IconHistory,
  IconHandStop,
  IconFilter,
  IconSearch,
  IconDownload,
  IconCalendar,
  IconTrash,
  Icon12Hours,
  IconCheck,
  IconX,
  IconEdit,
  IconView360,
} from "@tabler/icons-react";
import {
  MRT_ColumnFiltersState,
  MRT_SortingState,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MRT_ColumnDef,
  useMantineReactTable,
  MantineReactTable,
} from "mantine-react-table";
import {
  ActionIcon,
  Badge,
  Box,
  Button,
  Flex,
  Grid,
  Input,
  List,
  Menu,
  rem,
  Text,
  ScrollArea,
  Select,
  ThemeIcon,
  Tooltip,
} from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { getProcessDefSelect, getUsersSelect } from "../../const/getSelectApi";
import { _localization } from "../../config/location";
import { modals } from "@mantine/modals";
import Repository from "../../_base/helper/HttpHelper";
import { ProcessApprove } from "../../model/ProcessApprove";
import PopupProcess from "../History/PopupProcess";
import { TasksMeModel } from "../../model/_baseId";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";
import TaskProcess from "../Tasks/TaskProcess";
import { SelectListItem } from "../../_base/model/_base/SelectListItemBase";
import { pageTable } from "../../_base/_const/_constVar";
const ApproveTable = () => {
  //#region  table

  //data and fetching state
  const [data, setData] = useState<TasksMeModel[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  //table state
  const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>(
    []
  );
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  //
  const dataStatus = [
    { value: "1", label: "Đang duyệt" },
    { value: "2", label: "Đã duyệt" },
    { value: "3", label: "Từ chối" },
    { value: "4", label: "Hủy duyệt" },
  ];
  const [dateUsers, setUsers] = useState<SelectListItem[]>([]);
  const [dateProcessDef, setProcessDef] = useState<SelectListItem[]>([]);

  useEffect(() => {
    getUser();
    getProcessDef();
  }, []);

  async function getUser() {
    const data = await getUsersSelect();
    if (data && data.length > 0) setUsers(data);
  }

  async function getProcessDef() {
    const data = await getProcessDefSelect();
    if (data && data.length > 0) setProcessDef(data);
  }
  const [dateFrom, setDateFrom] = useState<Date | null>(null);
  const [dateTo, setDateTo] = useState<Date | null>(null);

  useEffect(() => {
    console.log("dsadsa" + dateFrom);
  }, [dateFrom]);

  useEffect(() => {
    fetchData();
  }, [pagination.pageIndex, pagination.pageSize, sorting]);

  const [contentSearch, setContentSearch] = useState<boolean>(false);
  const [keySearch, setKeySearch] = useState<string>("");
  const [processDefId, setprocessDefId] = useState<number>(0);
  const [createdById, setcreatedById] = useState<number>(0);
  const [status, setStatus] = useState<number>(0);
  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setOpenedMenu(false);
    const url = new URL("/api/v1/folders/task", "https://localhost:7118");
    url.searchParams.set("page", `${pagination.pageIndex}`);
    url.searchParams.set("pageSize", `${pagination.pageSize}`);
    if (keySearch && keySearch.length > 0)
      url.searchParams.set("key", `${keySearch}`);
    if (dateFrom)
      url.searchParams.set(
        "fromDate",
        `${dateFrom?.getFullYear()}-${
          dateFrom?.getMonth() + 1
        }-${dateFrom?.getDate()}`
      );
    if (dateTo)
      url.searchParams.set(
        "toDate",
        `${dateTo?.getFullYear()}-${
          dateTo?.getMonth() + 1
        }-${dateTo?.getDate()} `
      );
    if (processDefId && processDefId > 0)
      url.searchParams.set("processDefId", `${processDefId}`);
    if (createdById && createdById > 0)
      url.searchParams.set("createdById", `${createdById}`);
    let _softing = "";
    if (sorting && sorting.length > 0) {
      let _q = sorting[0];
      if (_q) _softing = _q.id;
    }
  
    if (status && status > 0) url.searchParams.set("status", `${status}`);
    try {
      const response = await fetch(url.href);
      const json = (await response.json()) as MessageResponse<any>;
      setData(json.data.data);
      setRowCount(json.data.count);
    } catch (error) {
      setIsError(true);
      console.error(error);
      return;
    }
    setIsError(false);
    setIsLoading(false);
    setIsRefetching(false);
  };

  const openHistoryFlow = async (id: number) => {
    if (id > 0) {
      const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);
      let url = "/history/history-flow-step?processId=" + id;
      let callapi = await repository.get<MessageResponse<ProcessApprove[]>>(
        url
      );
      if (callapi?.success && callapi.data) {
        modals.openConfirmModal({
          title: "",
          children: (
            <>
              <div className="e-card-header">
                <div className="e-card-header-caption">
                  <div className="e-card-header-title e-card-3-black">
                    Quá trình duyệt
                  </div>
                </div>
              </div>
              <Grid>
                <Grid.Col span={8}>
                  <PopupProcess data={callapi.data}></PopupProcess>
                </Grid.Col>
                <Grid.Col span={4}>
                  <Text fw={600} mb={"sm"}>
                    Chú thích
                  </Text>
                  <List
                    spacing="xs"
                    size="sm"
                    center
                    icon={
                      <IconCheck style={{ width: rem(18), height: rem(18) }} />
                    }
                  >
                    <List.Item
                      icon={
                        <ThemeIcon color="blue" size={26} radius="xl">
                          <IconCheck
                            style={{ width: rem(25), height: rem(25) }}
                          />
                        </ThemeIcon>
                      }
                    >
                      Đã duyệt thành công
                    </List.Item>
                    <List.Item
                      icon={
                        <ThemeIcon color="red" size={26} radius="xl">
                          <IconX style={{ width: rem(20), height: rem(20) }} />
                        </ThemeIcon>
                      }
                    >
                      Từ chối phê duyệt
                    </List.Item>
                    <List.Item
                      icon={
                        <ThemeIcon color="gray" size={26} radius="xl">
                          <Icon12Hours
                            style={{ width: rem(20), height: rem(20) }}
                          />
                        </ThemeIcon>
                      }
                    >
                      Chưa được xử lý
                    </List.Item>
                  </List>
                </Grid.Col>
              </Grid>
            </>
          ),
          labels: { confirm: "Đóng", cancel: "Cancel" },
          onCancel: () => console.log("Cancel"),
          onConfirm: () => console.log("Confirmed"),
          cancelProps: { display: "none" },
          size: "70%",
          scrollAreaComponent: ScrollArea.Autosize,
        });
      } else NotificationExtension.Info("Không có lịch sử phê duyệt !");
    }
  };

  function progessTemplate(props: TasksMeModel): any {
    return (
      <>
        <Tooltip label="Lịch sử phê duyệt">
          <ActionIcon
            onClick={async (e) => {
              await openHistoryFlow(props.idNode);
            }}
            variant="light"
            aria-label="Settings"
            color="cyan"
          >
            <IconHistory size={14} stroke={1.5} />
          </ActionIcon>
        </Tooltip>
        <Tooltip label="Xem">
          <ActionIcon variant="light" aria-label="Settings" color="red">
            <IconView360 size={14} stroke={1.5} />
          </ActionIcon>
        </Tooltip>
        <Tooltip label="Chỉnh sửa">
          <ActionIcon
            onClick={() => {
              modals.openConfirmModal({
                title: (
                  <>
                    <div
                      className="e-card-header-title e-card-3"
                      style={{ color: "black" }}
                    >
                      Quá trình duyệt
                    </div>
                  </>
                ),
                centered: true,
                size: "95%",
                children: (
                  <>
                    <TaskProcess />
                  </>
                ),
                labels: { confirm: "Confirm", cancel: "Hủy bỏ" },
                onCancel: () => console.log("Cancel"),
                onConfirm: () => console.log("Confirmed"),
                confirmProps: { display: "none" },
              });
            }}
            variant="light"
            aria-label="Settings"
            color="red"
          >
            <IconEdit size={14} stroke={1.5} />
          </ActionIcon>
        </Tooltip>
        <Tooltip label="Dừng phê duyệt">
          <ActionIcon variant="light" aria-label="Settings" color="red">
            <IconTrash size={14} stroke={1.5} />
          </ActionIcon>
        </Tooltip>
      </>
    );
  }

  function getColorStatus(text: string) {
    switch (text.trim()) {
      case "Ký ảnh":
        return "blue";
      case "Ký số":
        return "teal";
      default:
        return "orange";
    }
  }

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "id",
        header: "Id",
      },
      {
        accessorKey: "code",
        header: "Mã hồ sơ",
        size: 30,
      },
      {
        accessorKey: "title",
        header: "Tên hồ sơ",
        size: 200,
      },
      {
        accessorKey: "nameTask",
        header: "Tên công việc",
        size: 100,
      },
      {
        accessorKey: "type",
        enableSorting: false,
        header: "Loại ký",
        Cell: ({ renderedCellValue, row }) => (
          <>
            <Badge color={getColorStatus(renderedCellValue?.toString() ?? "")}>
              {renderedCellValue}
            </Badge>
          </>
        ),
      },

      {
        accessorKey: "dateCreate",
        header: "Ngày tạo",
      },

      {
        accessorKey: "dateEx",
        header: "Ngày hết hạn",
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        size: 50,
        Cell: ({ renderedCellValue, row }) => (
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              gap: "16px",
            }}
          >
            {progessTemplate(row.original)}
          </Box>
        ),
      },
    ],
    []
  );
  const [openedMenu, setOpenedMenu] = useState(false);
  React.useEffect(() => {
    //do something when the row selection changes...
    console.info({ rowSelection });
  }, [rowSelection]);

  const table = useMantineReactTable({
    columns,
    data,
    positionToolbarAlertBanner: "bottom",
    //add custom action buttons to top-left of top toolbar
    renderTopToolbarCustomActions: ({ table }) => (
      <>
        <Flex
          gap="md"
          justify="flex-start"
          align="center"
          direction="row"
          wrap="wrap"
        >
          <Input
            placeholder="Nhập từ khóa"
            onChange={(e) => {
              setKeySearch(e.target.value ?? "");
            }}
          />

          <Menu
            shadow="md"
            trigger="hover"
            openDelay={100}
            closeDelay={200}
            opened={openedMenu}
            withArrow
            // onChange={(e)=>{
            //     setOpened111(true)
            // }}
          >
            <Menu.Target>
              <Button
                rightSection={<IconFilter size={14} />}
                color="teal"
                variant="outline"
                onClick={(e) => {
                  setOpenedMenu(!openedMenu);
                }}
              >
                Bộ lọc
              </Button>
            </Menu.Target>

            <Menu.Dropdown>
              <>
                <div style={{ padding: "10px", minWidth: "300px" }}>
                  <DatePickerInput
                    id="fromDatePickerInput"
                    key="fromDatePickerInput"
                    clearable
                    label="Từ ngày"
                    placeholder="Chọn ngày..."
                    valueFormat="DD-MM-YYYY"
                    value={dateFrom}
                    onChange={setDateFrom}
                    leftSection={
                      <IconCalendar
                        style={{ width: rem(18), height: rem(18) }}
                        stroke={1.5}
                      />
                    }
                    leftSectionPointerEvents="none"
                  />
                  <DatePickerInput
                    id="toDatePickerInput"
                    key="toDatePickerInput"
                    clearable
                    label="Đến ngày"
                    placeholder="Chọn ngày..."
                    valueFormat="DD-MM-YYYY"
                    value={dateTo}
                    onChange={setDateTo}
                    leftSection={
                      <IconCalendar
                        style={{ width: rem(18), height: rem(18) }}
                        stroke={1.5}
                      />
                    }
                    leftSectionPointerEvents="none"
                  />
                  <Select
                    id="flowModel"
                    label="Quy trình mẫu"
                    placeholder="Chọn"
                    data={dateProcessDef?.map((item: SelectListItem) => {
                      return {
                        value: item.value,
                        label: item.text,
                      };
                    })}
                    value={processDefId.toString()}
                    onChange={(e) => {
                      const value = parseFloat(e ?? ""); // Convert giá trị nhập thành số
                      if (!isNaN(value) && e) {
                        setprocessDefId(parseFloat(e));
                      } else {
                        setprocessDefId(0);
                      }
                    }}
                    nothingFoundMessage="Không có dữ liệu"
                    searchable
                    clearable
                  />
                  <Select
                    id="createBy"
                    label="Người tạo"
                    placeholder="Chọn"
                    data={dateUsers?.map((item: SelectListItem) => {
                      return {
                        value: item.value,
                        label: item.text,
                      };
                    })}
                    value={createdById.toString()}
                    onChange={(e) => {
                      const value = parseFloat(e ?? ""); // Convert giá trị nhập thành số
                      if (!isNaN(value) && e) {
                        setcreatedById(parseFloat(e));
                      } else {
                        setcreatedById(0);
                      }
                    }}
                    nothingFoundMessage="Không có dữ liệu"
                    searchable
                    clearable
                  />
                </div>
              </>
            </Menu.Dropdown>
          </Menu>
          <Button
            leftSection={<IconSearch size={14} />}
            color="blue"
            variant="outline"
            onClick={async () => {
              await fetchData();
            }}
          >
            Tìm kiếm
          </Button>
        </Flex>
      </>
    ),
    renderToolbarInternalActions: ({ table }) => (
      <>
        <Flex
          gap="md"
          justify={{ sm: "flex-start", lg: "flex-end" }}
          align="center"
          direction="row"
          wrap="wrap"
        >
          <Button
            leftSection={<IconDownload size={14} />}
            color="violet"
            variant="outline"
          >
            Export Excel
          </Button>
        </Flex>
      </>
    ),

    localization: _localization,
    enableRowSelection: true,
    getRowId: (row) => row.id,
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["mrt-row-select", "code"],
        right: ["action"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTableContainerProps: { style: { maxHeight: "60vh" } },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    manualFiltering: true,
    manualPagination: true,
    manualSorting: true,
    rowCount,
    onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        //  fontWeight: row.getIsSelected() ? "bold" : "normal", //conditional styling
        fontWeight: "bold", //conditional styling
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      columnFilters,
      globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      sorting,
      rowSelection,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: pageTable,
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: true,
    },
  });

  //#endregion
  return (
    <>
      <div className="mt-5">
        <MantineReactTable table={table} />
      </div>
    </>
  );
};
export default ApproveTable;
